export const DEVICE_NAMES = {
  VODAPAY_CHOP_CHOP: 'VodaPay Chop-Chop',
  VODAPAY_ECOM_GATEWAY: 'VodaPay Payment Gateway',
  VODAPAY_KWIKA: 'VodaPay Kwika',
  VODAPAY_MAX: 'VodaPay Max',
  INSTANT_EFT: 'Instant EFT (Ozow)',
  QR_SCAN_TO_PAY: 'QR (Scan to Pay)',
  VISA_MASTERCARD: 'Visa/ Mastercard',
  AMERICAN_EXPRESS_DINERS: 'American Express/ Diners',
  BIZ_WALLET_PRO: 'Biz Wallet Pro',
  BIZ_PRO_WALLET: 'Business Pro Wallet',
  TAP_ON_PHONE: 'VodaPay Tap on Phone',
  MAX_2: 'VodaPay Max 2',
  VODAPAY_PAYMENT_REQUEST: 'VodaPay Payment Request',
};

export const VIRTUAL_DEVICES = [
  DEVICE_NAMES.VODAPAY_CHOP_CHOP,
  DEVICE_NAMES.VODAPAY_ECOM_GATEWAY,
  DEVICE_NAMES.TAP_ON_PHONE,
  DEVICE_NAMES.VODAPAY_PAYMENT_REQUEST,
  DEVICE_NAMES.BIZ_PRO_WALLET,
  DEVICE_NAMES.AMERICAN_EXPRESS_DINERS,
  DEVICE_NAMES.BIZ_WALLET_PRO,
  DEVICE_NAMES.INSTANT_EFT,
  DEVICE_NAMES.QR_SCAN_TO_PAY,
  DEVICE_NAMES.VISA_MASTERCARD,
];

export const PRODUCT_CATEGORY_NAME_MAP = {
  [DEVICE_NAMES.VODAPAY_ECOM_GATEWAY]: 'E commerce Gateway',
  [DEVICE_NAMES.VODAPAY_PAYMENT_REQUEST]: 'Payment Request',
};